<input class="file-field__input clear-field" [accept]="fileTypes" [id]="inputId" type="file" (blur)="touched()" />
